<!-- 学员评价 -->
<template>
  <div class="box14">
    <div class="titleBox">
      <div class="title">拥抱新机遇 他们已经开始</div>
      <div class="subtitle">
        深夜你在刷视频的时候，他们已经开始利用短视频变现了
      </div>
    </div>
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="rgb(234, 229, 255)"
      blockColor="rgb(69, 62, 255)"
      step="6"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    studentEvaluation,
    previewImage,
  },
  data() {
    return {
      cur: 0,
      isPreview: false,
      clickedIndex: 0,

      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/media/box14/1.jpg"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/media/box14/5.jpg"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/media/box14/3.jpg"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/media/box14/4.jpg"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/media/box14/2.jpg"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/media/box14/6.jpg"),
              id: 6,
            },
          ],
        },
      ],
      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem  solid rgb(234, 229, 255);",
        imgHoverBorder: "border: 0.053333rem  solid rgb(69, 62, 255);",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      if (this.evaluateData[this.cur].imgUrlList) {
        this.isPreview = true;
      }
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.box14 {
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  padding-bottom: 88px;

  .titleBox {
    margin-top: 80px;
    text-align: center;

    .title {
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
}
</style>
